<template>
  <b-dropdown-item
    link-class="d-flex align-items-center justify-content-between"
    class="location-permissions"
    @click="handleLocationPermissionClick"
  >
    <div
      v-b-tooltip
      class="d-flex align-items-center"
      :title="$t(tooltipKey)"
    >
      <feather-icon
        size="16"
        icon="MapPinIcon"
        :class="['mr-50', locationPermissionGranted ? 'text-success' : 'text-danger']"
      />
      <span :class="[locationPermissionGranted ? 'text-success' : 'text-danger']">
        {{ $t('user-profile.location-permissions.label') }}
      </span>
    </div>
  </b-dropdown-item>
</template>

<script>
import { BDropdownItem, VBTooltip } from 'bootstrap-vue'

export default {
  name: 'LocationPermissionItem',
  components: { BDropdownItem },
  directives: { 'b-tooltip': VBTooltip },
  data() {
    return {
      locationPermissionState: null,
      geolocationPermissionStatus: null,
    }
  },
  computed: {
    locationPermissionGranted() {
      return this.locationPermissionState === 'granted'
    },
    tooltipKey() {
      return this.locationPermissionGranted
        ? 'user-profile.location-permissions.granted'
        : 'user-profile.location-permissions.denied'
    },
  },
  mounted() {
    this.initLocationPermissionState()
  },
  beforeDestroy() {
    if (this.geolocationPermissionStatus) {
      this.geolocationPermissionStatus.onchange = null
    }
  },
  methods: {
    async initLocationPermissionState() {
      if (typeof window === 'undefined') {
        return
      }
      if (!navigator.permissions || !navigator.permissions.query) {
        this.locationPermissionState = navigator.geolocation ? 'prompt' : 'denied'
        return
      }
      try {
        const status = await navigator.permissions.query({ name: 'geolocation' })
        this.geolocationPermissionStatus = status
        this.locationPermissionState = status.state
        status.onchange = () => {
          this.locationPermissionState = status.state
        }
      } catch (error) {
        this.locationPermissionState = 'prompt'
      }
    },
    handleLocationPermissionClick() {
      if (this.locationPermissionGranted) {
        return
      }
      this.requestLocationPermission()
    },
    requestLocationPermission() {
      if (typeof window === 'undefined' || !navigator.geolocation) {
        return
      }
      navigator.geolocation.getCurrentPosition(
        () => {
          this.locationPermissionState = 'granted'
        },
        () => {
          this.locationPermissionState = 'denied'
        },
      )
    },
  },
}
</script>
